
import React from "react";
import { Classname } from "@rivtn/noseur";
import { IAchievement } from "../../data";
import styles from "../../assets/style.module.css";

export interface AchievementCardProps {
    index?: number;
    visible?: boolean;
    achievement: IAchievement;
}

function AchievementCard({ achievement: a, index = 0, visible = true }: AchievementCardProps) {
    return (<div className={Classname.build(styles["honour"], styles["reveal"], { [styles["in-view"]]: visible })} style={{ transitionDelay: `${index * 0.06}s` }}>
        <div className={styles["honour-icon"]}><i className={a.icon} /></div>
        <div className={styles["honour-head"]}>
            <div className={styles["honour-title"]}>{a.title}</div>
        </div>
        <div className={styles["honour-desc"]}>{a.desc}</div>
        <div className={styles["chips"]}>
            <span className={styles["chip"]}>{a.year}</span>
        </div>
    </div>);
}

export default AchievementCard;
